import styled from 'styled-components';

export const OuterWrapper = styled.div`
  position: fixed;
  left: 120px;
  bottom: 40px;
  z-index: 2;
`;

export const Wrapper = styled.div<{ leftActive: boolean }>`
  background-color: var(--colorBlueGray900);
  border-radius: 8px;
  box-shadow: 0px 0px 15px -7px rgba(0, 0, 0, 0.32), 0px 0px 46px 8px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.24);
  height: 64px;
  padding: 4px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  width: max-content;
  position: relative;

  &:before {
    content: '';
    background-color: var(--colorBlueGray50);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.5);
    width: 130px;
    height: calc(100% - 8px);
    border-radius: 6px;
    position: absolute;
    top: 4px;
    transform: ${({ leftActive }) =>
      leftActive ? 'translateX(0)' : 'translateX(calc(100% + 4px))'};
    transition: transform 0.2s ease-in-out;
  }
`;

export const ToggleItem = styled.div<{ leftActive: boolean }>`
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  width: 130px;
  cursor: pointer;
  user-select: none;
  z-index: 1;
  color: ${({ leftActive }) => (leftActive ? 'var(--colorWhite)' : 'var(--colorBlueGray1200)')};
  transition: color 0.2s ease-in-out;

  &:first-child {
    color: ${({ leftActive }) => (leftActive ? 'var(--colorBlueGray1200)' : 'var(--colorWhite)')};
    margin-right: 4px;
  }
`;
